import auth from '@/app/auth'
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import app from '@/app/app'
import ui from '@/app/ui';

const metaSuper = { meta: {feature:"super"} };
const metaAdminFeature = { meta: {feature:"admin"} };
const metaAdmin = { meta: {feature:"admin", section:'admin'} };
const metaBilling = { meta: {feature:"admin", section:'admin'} };

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/super/parkimport',
    name: 'ParkImport',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ParkImport.vue')
  },
  {
    path: '/pruebas',
    name: 'pruebas',
    component: () => import( '../views/PruebasPage.vue')
  },


  { name: 'change-password', path:'/change-password',   component: () => import( '../views/ChangePasswordPage.vue')  },
  { name: 'tx-entry'   , path:'/tools/tx-entry',           component: () => import( '../views/tools/TxEntry.vue') , ...metaSuper },

  { name: 'login'   , path:'/login',               component: () => import( '../views/public/LoginPage.vue') , meta: {layout:"public"} },
  { name: 'search'  , path:'/search',              component: () => import( '../views/SearchPage.vue')  },
  { name: 'error404', path:'/:pathMatch(.*)*',     component: () => import( '../views/errorPages/NotFound404.vue')  },
  { name: 'error403', path:'/forbidden',           component: () => import( '../views/errorPages/ForbiddenPage403.vue')  },
  {  path:'/:parking(\\d+)+',
     children: [
      { name: 'booking-new'    , path:'booking/new'  ,   component: () => import( '../views/booking/NewBookingPage.vue')   },
      { name: 'booking-list'   , path:'booking/list/:listMode?' ,  component: () => import( '../views/booking/BookingListPage.vue')  },
      { name: 'clients-new'    , path:'clients/new'  ,   component: () => import( '../views/client/ClientAddPage.vue')   },
      { name: 'coupons-new'    , path:'coupons/new'  ,   component: () => import( '../views/coupon/CouponAddPage.vue')   },
      { name: 'couponsclient-new'    , path:'couponsclient/new'  ,   component: () => import( '../views/coupon_client/CouponclientAddPage.vue')   },
      { path:'booking/:id'  ,   component: () => import( '../views/booking/BookingMainPage.vue'),
        children: [
          { path:'info'            ,   component: () => import( '../views/booking/BookingInfoPage.vue')   },
          { path:'editor'            ,   component: () => import( '../views/booking/BookingEditorPage.vue')   },
          { path:'invoices'          ,   component: () => import( '../views/booking/BookingInvoicesPage.vue')   },
        ]
      },
      { path:'client/:id'  ,   component: () => import( '../views/client/ClientMainPage.vue'),
      children: [
        { path:'info'            ,   component: () => import( '../views/client/ClientInfoPage.vue')   },
        { path:'editor'            ,   component: () => import( '../views/client/ClientEditorPage.vue')   },
        { path:'bookings'          ,   component: () => import( '../views/client/ClientBookingListPage.vue')   },
      ]
    },
    { path:'coupon/:id'  ,   component: () => import( '../views/coupon/CouponMainPage.vue'),
    children: [
      { path:'info'            ,   component: () => import( '../views/coupon/CouponInfoPage.vue')   },
      { path:'editor'            ,   component: () => import( '../views/coupon/CouponEditorPage.vue')   },
    ]
  },
  { path:'couponclient/:id'  ,   component: () => import( '../views/coupon_client/CouponclientMainPage.vue'),
  children: [
    { path:'info'            ,   component: () => import( '../views/coupon_client/CouponclientInfoPage.vue')   },
    { path:'editor'            ,   component: () => import( '../views/coupon_client/CouponclientEditorPage.vue')   },
  ]
},
      { name: 'ops-summary'    , path:'ops/summary/:date?'  ,  component: () => import( '../views/ops/OpsSummaryPage.vue')  },
      { name: 'ops-ins'    , path:'ops/ins/:date?'  ,  component: () => import( '../views/ops/OpsInsPage.vue')  },
      { name: 'ops-outs'    , path:'ops/outs/:date?'  ,  component: () => import( '../views/ops/OpsOutsPage.vue')  },
      { name: 'ops-labels'    , path:'ops/labels/:date?'  ,  component: () => import( '../views/ops/OpsLabelsPage.vue')  },

      { path:'billing/invoice-list'           ,  component: () => import( '../views/billing/InvoiceListPage.vue')  , ...metaBilling },
      { path:'clients/client-list'           ,  component: () => import( '../views/client/ClientListPage.vue')  , ...metaBilling },
      { path:'coupons/coupon-list'           ,  component: () => import( '../views/coupon/CouponListPage.vue')  },
      { path:'couponsclient/couponclient-list'           ,  component: () => import( '../views/coupon_client/CouponclientListPage.vue')  },
     
      { path:'admin/parking'                ,  component: () => import( '../views/admin/AdminParkingPage.vue')  , ...metaAdmin },
      { path:'admin/automatic-cancellation' ,  component: () => import( '../views/admin/AutomaticCancellationPage.vue')  , ...metaAdmin },
      { path:'admin/tolerance-minutes'      ,  component: () => import( '../views/admin/ToleranceMinutesPage.vue')  , ...metaAdmin },
      { path:'admin/price-calculation'      ,  component: () => import( '../views/admin/PriceCalculationPage.vue')  , ...metaAdmin },
      { path:'admin/user'                   ,  component: () => import( '../views/admin/users/UserAdminPage.vue')  , ...metaAdmin },
      { path:'admin/product'                   ,  component: () => import( '../views/admin/product/ProductListPage.vue')  , ...metaAdmin },
      { path:'admin/parking'                ,  component: () => import( '../views/admin/AdminParkingPage.vue')  , ...metaAdmin },
      { path:'admin/email-template' ,     component: () => import( '../views/admin/email/EmailTemplatePage.vue') , ...metaAdmin },
      { path:'admin/email-style'   ,     component: () => import( '../views/admin/email/EmailStylePage.vue') , ...metaAdmin },
      { path:'admin/billing-configuration'   ,     component: () => import( '../views/admin/billing/CompanyPage.vue') , ...metaAdmin },
      { path:'admin/billing-invoice-template'   ,     component: () => import( '../views/admin/billing/InvoiceTemplatePage.vue') , ...metaAdmin },
      { path:'admin/calendar-config'   ,     component: () => import( '../views/admin/CalendarDatesEditorPage.vue') , ...metaAdmin },

    ]
  },


  { name: 'smtp-cfg'       , path:'/super/smtp-cfg',           component: () => import( '../views/super/SmtpCfgPage.vue') , ...metaSuper },
  //{ name: 'email-style'    , path:'/admin/email-style'   ,     component: () => import( '../views/admin/email/EmailStylePage.vue') , ...metaAdmin },



]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(async (to, from) => {
    let hasToken = auth.hasTokenStored();


    if (!hasToken) {
        if (to.name !== 'login')
            return { name: 'login' }
        else return true;
    }


    if (to.name === 'login')
        return  hasToken ? {name: 'home' } : false;

    await app._requireSession();

    if (!auth.isLoggedIn())
        return { name: 'login' }

    if (to?.meta?.feature)
        if (!auth.hasFeature(to.meta.feature))
            return ({ name: 'error403' });

    if (to?.params?.parking) {
        let ok = await app.setParking(parseInt(to.params.parking[0]));
        if (!ok)
            return { name: 'home' };
    }

    if (to?.meta?.section)
        ui.mainMenuShowSection(to.meta.section);
});


export default router;
